<template>
  <!--
      作者 kmdshop
      时间：2019-10-26
      描述：设置-商城设置-应急预案编制小组配置
  -->
  <div class="product-add">
    <!-- 表单容器 -->
    <el-form
      size="small"
      ref="teamForm"
      :model="form"
      :rules="formRules"
      label-width="150px"
      class="team-form"
    >
      <!-- 表单标题 -->
      <div class="common-form">应急预案编制小组设置</div>

      <!-- 组长选择 -->
      <el-form-item label="组长" prop="leader">
        <el-select v-model="form.leader" placeholder="请选择组长" clearable>
          <el-option label="全部" value="0"></el-option>
          <el-option
            v-for="item in peopleList"
            :key="item.ma_employee_id"
            :label="`${item.name}(${item.depart_name || '无部门'})`"
            :value="item.ma_employee_id"
          ></el-option>
        </el-select>
      </el-form-item>

      <!-- 副组长选择 -->
      <el-form-item label="副组长" prop="deputyLeader">
        <el-select v-model="form.deputyLeader" placeholder="请选择副组长" clearable>
          <el-option label="全部" value="0"></el-option>
          <el-option
            v-for="item in peopleList"
            :key="item.ma_employee_id"
            :label="`${item.name}(${item.depart_name || '无部门'})`"
            :value="item.ma_employee_id"
          ></el-option>
        </el-select>
      </el-form-item>

      <!-- 成员选择（多选） -->
      <el-form-item label="成员" prop="members">
        <el-select
          v-model="form.members"
          multiple
          style="width: 400px"
          placeholder="请选小组成员"
          clearable
        >
          <el-option
            v-for="item in peopleList"
            :key="item.ma_employee_id"
            :label="item.name"
            :value="item.ma_employee_id"
          ></el-option>
        </el-select>
      </el-form-item>

      <!-- 组员职责 -->
      <el-form-item label="组员职责" prop="memberDuty">
        <el-input
          v-model="form.memberDuty"
          placeholder="请输入组员职责"
          type="textarea"
          :rows="10"
          class="max-w460"
        ></el-input>
      </el-form-item>

      <!-- 组长职责 -->
      <el-form-item label="组长职责" prop="leaderDuty">
        <el-input
          v-model="form.leaderDuty"
          placeholder="请输入组长职责"
          type="textarea"
          :rows="10"
          class="max-w460"
        ></el-input>
      </el-form-item>

      <!-- 成立时间 -->
      <el-form-item label="成立时间" prop="establishDate">
        <el-date-picker
          v-model="form.establishDate"
          type="date"
          placeholder="请选择编制小组成立日期"
          class="max-w460"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
      </el-form-item>

      <!-- 提交按钮 -->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="submitForm" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import SettingApi from '@/api/setting.js'
import _ from 'lodash'

export default {
  name: 'TeamSetting', // 组件命名
  data() {
    return {
      // 加载状态
      loading: false,
      // 表单数据（语义化命名，修复原数据结构错误）
      form: {
        leader: '', // 组长
        deputyLeader: '', // 副组长
        members: [], // 成员（多选，初始值为数组）
        memberDuty: '', // 组员职责
        leaderDuty: '', // 组长职责
        establishDate: '' // 成立时间
      },
      // 人员列表
      peopleList: [],
      // 表单校验规则
      formRules: {
        leader: [
          { required: true, message: '请组长', trigger: 'change' }
        ],
        deputyLeader: [
          { required: true, message: '请选择副组长', trigger: 'change' }
        ],
        members: [
          { type: 'array', required: true, min: 1, message: '成员至少选择一个', trigger: 'change' }
        ],
        establishDate: [
          { required: true, message: '请选择成立时间', trigger: 'change' }
        ],
        leaderDuty: [
          { required: true, message: '请输入组长职责', trigger: 'blur' }
        ],
        memberDuty: [
          { required: true, message: '请输入组员职责', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    // 初始化获取应急预案编制小组详情
    this.getTeamDetail()
  },
  methods: {
    /**
     * 获取应急预案编制小组配置详情
     */
    async getTeamDetail() {
      try {
        this.loading = true
        const res = await SettingApi.teamDetail({}, true)
        if (res.code) { // 假设接口成功码为200，根据实际情况调整
          // 合并表单数据（兼容接口返回字段）
          const formData = _.merge({}, this.form, res.data.vars.values)
          // 处理成员字段（确保是数组）
          this.form = {
            ...formData,
            members: formData.members || formData.members || []
          }
          // 赋值人员列表
          this.peopleList = res.data.people_list || []
        } else {
          this.$message.error(res.msg || '获取配置失败')
        }
      } catch (error) {
        console.error('获取详情失败：', error)
        this.$message.error('网络异常，获取数据失败')
      } finally {
        this.loading = false
      }
    },

    /**
     * 提交表单
     */
    async submitForm() {
      // 先校验表单
      const valid = await this.$refs.teamForm.validate()
      if (!valid) return

      try {
        this.loading = true
        // 构造提交参数（兼容原接口字段）
        const submitParams = {
          leader: this.form.leader,
          deputyLeader: this.form.deputyLeader,
          members: this.form.members,
          memberDuty: this.form.memberDuty,
          leaderDuty: this.form.leaderDuty,
          establishDate: this.form.establishDate
        }
        // 提交接口
        const res = await SettingApi.editTeam(submitParams, true)
        if (res.code === 1) {
          this.$message.success('设置成功')
          this.$router.push('/setting/team/index')
        } else {
          this.$message.error(res.msg || '提交失败')
        }
      } catch (error) {
        console.error('提交配置失败：', error)
        this.$message.error('网络异常，提交失败')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
// 表单容器样式
.team-form {
  padding: 20px 0;
}

// 标题样式
.common-form {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #333;
}

// 按钮容器
.common-button-wrapper {
  margin-top: 30px;
}

// 输入框最大宽度
.max-w460 {
  max-width: 460px;
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/setting/team/index.vue